/* Hikora TCG — Shopify theme. Vanilla JS, no framework. */
(() => {
  const $  = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => Array.from(root.querySelectorAll(s));

  const cfg = window.HIKORA || {};
  const money = (cents) => {
    const v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return `${cfg.moneySymbol || ''}${v}`;
  };

  // ===================================================================
  // Cart drawer
  // ===================================================================
  const drawer = $('[data-cart-drawer]');
  const cartCountEls = $$('[data-cart-count]');

  const openCart = () => {
    drawer?.classList.add('open');
    drawer?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  const closeCart = () => {
    drawer?.classList.remove('open');
    drawer?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  $$('[data-cart-toggle]').forEach((el) =>
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
      refreshCart();
    })
  );
  $$('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCart));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      renderCart(await res.json());
    } catch (err) {
      console.error('cart fetch failed', err);
    }
  }

  function renderCart(cart) {
    cartCountEls.forEach((el) => {
      if (cart.item_count > 0) { el.textContent = String(cart.item_count); el.hidden = false; }
      else { el.hidden = true; }
    });

    const itemsEl = $('[data-cart-items]', drawer);
    const subtotalEl = $('[data-cart-subtotal]', drawer);
    const footerEl = $('[data-cart-footer]', drawer);
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div class="cart-empty">
          <span class="sparkle" aria-hidden="true">${cfg.sparkleSvg || ''}</span>
          <p>Your cart's empty — go catch 'em!</p>
        </div>`;
      if (footerEl) footerEl.hidden = true;
      return;
    }
    if (footerEl) footerEl.hidden = false;

    itemsEl.innerHTML = cart.items
      .map((item) => `
        <div class="cart-item" data-key="${item.key}">
          <img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : ''}" alt="" loading="lazy" />
          <div class="cart-item-info">
            <h3><a href="${item.url}">${item.product_title}</a></h3>
            ${item.variant_title && !/default/i.test(item.variant_title) ? `<div class="variant">${item.variant_title}</div>` : ''}
            <div class="price">${item.quantity} × ${money(item.final_price)}</div>
            <button type="button" class="remove" data-remove="${item.key}">Remove</button>
          </div>
        </div>`)
      .join('');

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    $$('[data-remove]', itemsEl).forEach((btn) => {
      btn.addEventListener('click', async () => {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.remove, quantity: 0 }),
        });
        refreshCart();
      });
    });
  }

  async function addToCart(idOrForm) {
    const body = idOrForm instanceof FormData ? idOrForm
      : JSON.stringify({ items: [{ id: idOrForm, quantity: 1 }] });
    const headers = idOrForm instanceof FormData
      ? { Accept: 'application/json' }
      : { Accept: 'application/json', 'Content-Type': 'application/json' };
    const res = await fetch('/cart/add.js', { method: 'POST', headers, body });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  // ===================================================================
  // Product page add-to-cart form
  // ===================================================================
  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = $('[type="submit"]', form);
      const label = submitBtn?.textContent;
      submitBtn?.setAttribute('aria-disabled', 'true');
      if (submitBtn) submitBtn.textContent = 'Adding…';
      try {
        await addToCart(new FormData(form));
        await refreshCart();
        openCart();
      } catch (err) {
        console.error(err);
        alert("Couldn't add to cart — please try again.");
      } finally {
        submitBtn?.removeAttribute('aria-disabled');
        if (submitBtn) submitBtn.textContent = submitBtn.dataset.label || label || 'Add to cart';
      }
    });
  });

  // ===================================================================
  // Quick-add buttons on product cards (single-variant products)
  // ===================================================================
  $$('[data-quick-add]').forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (btn.disabled) return;
      btn.classList.add('is-loading');
      try {
        await addToCart(btn.dataset.quickAdd);
        await refreshCart();
        openCart();
      } catch (err) {
        console.error(err);
        alert("Couldn't add to cart — please try again.");
      } finally {
        btn.classList.remove('is-loading');
      }
    });
  });

  // ===================================================================
  // Product gallery — thumbnail click swaps main image
  // ===================================================================
  const gallery = $('[data-gallery]');
  if (gallery) {
    const main = $('[data-gallery-main]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        $$('[data-gallery-thumb]', gallery).forEach((t) => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
        const full = thumb.dataset.full;
        const alt = thumb.dataset.alt || '';
        if (full && main) main.innerHTML = `<img src="${full}" alt="${alt}" />`;
      });
    });
  }

  // ===================================================================
  // Variant picker — update hidden id, price, availability
  // ===================================================================
  (function () {
    const form = $('[data-product-form]');
    if (!form || !window.HIKORA_VARIANTS || window.HIKORA_VARIANTS.length <= 1) return;
    const variants = window.HIKORA_VARIANTS;
    const priceEls = $$('[data-product-price]');
    const idEl = $('[data-variant-id]', form);

    const selection = () => $$('[data-variant-option]:checked', form).map((i) => i.value);

    function update() {
      const sel = selection();
      const v = variants.find((v) => JSON.stringify(v.options) === JSON.stringify(sel));
      if (!v) return;
      if (idEl) idEl.value = v.id;
      priceEls.forEach((el) => { el.textContent = money(v.price); });
      const submit = $('[type="submit"]', form);
      if (submit) {
        if (v.available) {
          submit.removeAttribute('aria-disabled');
          submit.disabled = false;
          submit.textContent = submit.dataset.label || 'Add to cart';
        } else {
          submit.setAttribute('aria-disabled', 'true');
          submit.disabled = true;
          submit.textContent = 'Sold out';
        }
      }
    }
    $$('[data-variant-option]', form).forEach((i) => i.addEventListener('change', update));
  })();

  // ===================================================================
  // Mobile menu drawer
  // ===================================================================
  const menuToggle = $('[data-menu-toggle]');
  const menu = $('[data-mobile-menu]');
  if (menuToggle && menu) {
    const setMenu = (open) => {
      menu.classList.toggle('open', open);
      menuToggle.setAttribute('aria-expanded', String(open));
      menu.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
    };
    menuToggle.addEventListener('click', () => setMenu(!menu.classList.contains('open')));
    $$('[data-menu-close]', menu).forEach((el) => el.addEventListener('click', () => setMenu(false)));
    $$('a', menu).forEach((a) => a.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setMenu(false); });
  }

  // ===================================================================
  // Announcement bar — rotating messages
  // ===================================================================
  (function () {
    const root = $('.ab-messages[data-messages]');
    if (!root) return;
    const span = $('.ab-msg', root);
    if (!span) return;
    let list;
    try { list = JSON.parse(root.getAttribute('data-messages') || '[]'); } catch (e) { list = []; }
    if (list.length <= 1) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const delay = parseInt(root.getAttribute('data-rotation'), 10) || 6000;
    let i = 0, paused = false;
    setInterval(() => {
      if (paused) return;
      i = (i + 1) % list.length;
      span.classList.add('fading');
      setTimeout(() => { span.innerHTML = list[i]; span.classList.remove('fading'); }, 200);
    }, delay);
    root.addEventListener('mouseenter', () => { paused = true; });
    root.addEventListener('mouseleave', () => { paused = false; });
  })();

  // Initial cart load
  refreshCart();
})();
